var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mb-1 text-caption"},[_vm._v(_vm._s(_vm.label))]),_c('div',{ref:"editor",staticClass:"editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }